module.exports = __webpack_public_path__ + "media/images/ui-icons_777777_256x240-af253b1b82b79498bcedad50d30d155b.png";